// src/pages/SykkelTilMinSide.jsx
// QR-koden på sykkelen lenker til /sykkel/<token>. Sykkelkortet ligger bak Din side:
// tokenet huskes i denne fanen, og kunden sendes til innloggingen. Etter innlogging
// viser Din side sykkelen hvis den hører til kontoen (CustomerPortal.jsx).
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const SYKKEL_NOKKEL = "minside_sykkel";

export default function SykkelTilMinSide() {
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    try {
      if (/^[A-Za-z0-9_-]{16,64}$/.test(String(token || ""))) sessionStorage.setItem(SYKKEL_NOKKEL, token);
    } catch {
      // Uten sessionStorage åpnes bare Din side.
    }
    navigate("/min-side", { replace: true });
  }, [token, navigate]);
  return null;
}
